import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router'
import { useEffect } from 'react'
import { toast } from 'sonner'
import { APP_ROUTES } from '@/common/constants'
import { APP } from '@/common/strings'
import { ONBOARDING_COPY } from '@/locales/en'
import { OnboardingAccountConfirmationSubmittedAnalytics } from '@/common/analytics/events/OnboardingAccountConfirmationSubmittedAnalytics'
import { useCurrentAccount } from '@/account/useCurrentAccount'
import { AccountConfirmationForm } from './features/account-confirmation/components/AccountConfirmationForm'
import { useAccountConfirmationLogic } from './features/account-confirmation/useAccountConfirmationLogic'
import { useOnboardingProgress } from './useOnboardingProgress'

export function AccountConfirmation() {
    const navigate = useNavigate()
    const { progress } = useOnboardingProgress()
    const logic = useAccountConfirmationLogic()
    const account = useCurrentAccount()

    useEffect(() => {
        if (account && !logic.isConfirmationRequired) {
            navigate(APP_ROUTES.DASHBOARD)
        }
    }, [account, logic.isConfirmationRequired, navigate])

    useEffect(() => {
        if (!logic.isSuccess) return
        OnboardingAccountConfirmationSubmittedAnalytics.track({
            accountId: account?.accountId || '',
            ...(account?.adviserId ? { adviserId: account.adviserId } : {}),
        })
        navigate(APP_ROUTES.DASHBOARD)
    }, [logic.isSuccess, navigate, account?.accountId, account?.adviserId])

    useEffect(() => {
        if (!logic.error) return
        toast.error(logic.error)
    }, [logic.error])

    if (!logic.isConfirmationRequired) {
        return null
    }

    return (
        <>
            <Helmet>
                <title>
                    {ONBOARDING_COPY.confirmation.pageTitle} | {APP.title}
                </title>
            </Helmet>
            <AccountConfirmationForm
                progress={progress}
                defaultValues={logic.data}
                loading={logic.loading}
                saving={logic.saving}
                onSubmit={logic.onSubmit}
            />
        </>
    )
}
